import http from '@/http';

export default {

    list() {
        return http.get('/units');
    },
};



// WEBPACK FOOTER //
// ./src/api/units.js